import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import HomePage from "@/pages/HomePage";
import LoginPage from "@/pages/LoginPage";
import AdminPage from "@/pages/AdminPage";
import AdminStatsPage from "@/pages/AdminStatsPage";
import ResultsPage from "@/pages/ResultsPage";
import ProjectsPage from "@/pages/ProjectsPage";
import ProjectsListPage from "@/pages/ProjectsListPage";
import ExtractionsPage from "@/pages/ExtractionsPage";
import AdminJointsPage from "@/pages/AdminJointsPage";
import AdminApiKeysPage from "@/pages/AdminApiKeysPage";
import ScanIqPage from "@/pages/ScanIqPage";
import SetPasswordPage from "@/pages/SetPasswordPage";

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/set-password" element={<SetPasswordPage kind="invite" />} />
            <Route path="/reset-password" element={<SetPasswordPage kind="reset" />} />
            
            {/* Admin only routes */}
            <Route path="/" element={
              <ProtectedRoute requireAdmin>
                <HomePage />
              </ProtectedRoute>
            } />
            <Route path="/uploads" element={
              <ProtectedRoute requireAdmin>
                <ExtractionsPage />
              </ProtectedRoute>
            } />
            <Route path="/results/:id" element={
              <ProtectedRoute requireAdmin>
                <ResultsPage />
              </ProtectedRoute>
            } />
            <Route path="/admin/users" element={
              <ProtectedRoute requireAdmin>
                <AdminPage />
              </ProtectedRoute>
            } />
            <Route path="/admin/stats" element={
              <ProtectedRoute requireAdmin>
                <AdminStatsPage />
              </ProtectedRoute>
            } />
            <Route path="/admin/joints" element={
              <ProtectedRoute requireAdmin>
                <AdminJointsPage />
              </ProtectedRoute>
            } />
            <Route path="/admin/api-keys" element={
              <ProtectedRoute requireAdmin>
                <AdminApiKeysPage />
              </ProtectedRoute>
            } />
            
            {/* Routes for regular users and admins (not viewers) */}
            <Route path="/projects" element={
              <ProtectedRoute allowUser>
                <ProjectsListPage />
              </ProtectedRoute>
            } />
            <Route path="/scan-iq" element={
              <ProtectedRoute>
                <ScanIqPage />
              </ProtectedRoute>
            } />
            <Route path="/projects/:id" element={
              <ProtectedRoute allowUser>
                <ProjectsPage />
              </ProtectedRoute>
            } />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
